import React from 'react';
import { isIOS, isSafari } from 'react-device-detect';
import { Box } from '@mui/material';
import PageLines from './PageLines';
import { determineStyleBasedOnLineWidth } from '../../utils/style-utils';

import { translate } from '../../translations/translator';
import { useDispatch, useSelector } from 'react-redux';
import { updateCursorPosition } from 'state/actions/action-creators';
const t = key => translate('worksheet', key);

const DoubleLinedInput = ({
  fontSize = 42,
  fontFamily = 'Print-Wide-Book',
  isCursive,
  isNarrow,
  onChange,
  numOfLinesArray,
  valueMap
}: any) => {
  const dispatch = useDispatch();
  const editedWorksheet = useSelector(({ worksheetMaker }: any) => worksheetMaker.editedWorksheet);
  const handleOnChange = ({ target }, index) => {
    onChange({ [index + 1]: target.value });
    const blueBackgroundDiv = document.getElementById(`blueBackground-${index + 1}`);
    if (blueBackgroundDiv && target?.value) {
      blueBackgroundDiv.id = `noBackground-${index + 1}`;
    }

    const noBackgroundDiv = document.getElementById(`noBackground-${index + 1}`);
    if (!target?.value && noBackgroundDiv) {
      noBackgroundDiv.id = `blueBackground-${index + 1}`;
    }
  };
  const textTop = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isSafari || isIOS ? '-24px' : '-30px',
    narrow: '-27px',
    cursive: isSafari || isIOS ? '-1px' : '-9px',
    regular: isIOS ? '-6px' : '-7px'
  });

  const lineHeight = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: '144px',
    narrow: '146px',
    cursive: '148px',
    regular: '150px'
  });

  const pageLinePadding = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: 13,
    narrow: 14,
    cursive: 20,
    regular: 21
  });

  const textareaStyles: any = {
    position: 'absolute',
    top: textTop,
    left: '36px',
    height: '340px',
    width: '775px',
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: fontSize,
    lineHeight: lineHeight,
    maxLines: 2,
    fontFamily: fontFamily,
    zIndex: 10
  };

  const boxStyles: any = {
    position: 'relative',
    marginTop: 10,
    width: '100%'
  };
  const handleBlur = ({ target }) => {
    dispatch(updateCursorPosition(+editedWorksheet.formKey, target.selectionStart));
  };

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      {numOfLinesArray.map((x, index) => {
        const pageLines = [...Array(4).keys()];
        return (
          <Box style={boxStyles} className={`doubleLineRow${index + 1}`}>
            {pageLines.map((lines, idx) => {
              return (
                <PageLines
                  width={775}
                  top={isNarrow ? 40 : 60}
                  isNarrow={isNarrow}
                  margin={isNarrow ? '55px 0' : '50px 0'}
                  isFirstLine={idx === 0}
                  sectionNumber={index + 1}
                  isLastLine={idx + 1 === pageLines.length}
                  isNotLastSection={index + 1 < numOfLinesArray.length}
                  addThickLine
                  paddingTop={pageLinePadding}
                  style={{
                    alignSelf: 'center',
                    position: 'relative',
                    zIndex: 2
                  }}
                />
              );
            })}
            <textarea
              id="doubleLineTextArea"
              style={textareaStyles}
              placeholder={`${t('sentence')} ${index + 1}`}
              wrap="hard"
              maxLength={140}
              onChange={e => handleOnChange(e, index)}
              value={valueMap[index + 1]}
              onBlur={handleBlur}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default DoubleLinedInput;
